<template>
  <component
    :is="to ? RouterLink : 'button'"
    v-bind="to ? { to } : { type }"
    :class="clases"
  >
    <slot />
    <IconArrowRight v-if="conFlecha" class="gob-btn-icono" aria-hidden="true" />
  </component>
</template>

<script>
import { RouterLink } from 'vue-router'
import { IconArrowRight } from '@tabler/icons-vue'

const CLASE_VARIANTE = { primario: 'gob-btn-primario', secundario: 'gob-btn-secundario' }
const CLASE_BLOQUE = { movil: 'gob-btn-bloque-movil', siempre: 'gob-btn-bloque-siempre', nunca: '' }

/**
 * GobButton
 * Regla de uso: todo CTA que lleva a /contacto es `primario`; cualquier otro es `secundario`.
 * Renderiza un router-link si recibe `to`; si no, un <button>. Las clases y los eventos del
 * padre (p. ej. class="nav-cta" o @click) se transmiten al elemento raíz.
 */
export default {
  name: 'GobButton',
  components: {
    IconArrowRight
  },
  props: {
    /** Ruta interna. Si existe, el botón es un router-link. */
    to: {
      type: String,
      default: null
    },
    /** Tipo del <button> cuando no hay `to` (p. ej. el submit del formulario de contacto). */
    type: {
      type: String,
      default: 'button',
      validator: (valor) => ['button', 'submit'].includes(valor)
    },
    /** Primario solo para CTAs que llevan a /contacto; por defecto secundario. */
    variante: {
      type: String,
      default: 'secundario',
      validator: (valor) => ['primario', 'secundario'].includes(valor)
    },
    /** `oscura` invierte los colores para fondos oscuros. */
    superficie: {
      type: String,
      default: 'clara',
      validator: (valor) => ['clara', 'oscura'].includes(valor)
    },
    /** `sm` es el tamaño del header; `md`, el de contenido. */
    tamano: {
      type: String,
      default: 'md',
      validator: (valor) => ['md', 'sm'].includes(valor)
    },
    /** Muestra la flecha Tabler a la derecha del texto. */
    conFlecha: {
      type: Boolean,
      default: false
    },
    /** Ancho completo: `movil` por debajo de 640 px, `siempre` o `nunca`. */
    bloque: {
      type: String,
      default: 'movil',
      validator: (valor) => ['movil', 'siempre', 'nunca'].includes(valor)
    }
  },
  data() {
    return {
      /** Referencia al componente RouterLink para el `<component :is>`. */
      RouterLink
    }
  },
  computed: {
    /**
     * clases
     * Combina las clases del sistema según las props. El brillo (`shadow-glow`) es exclusivo
     * del primario de contenido: tamaño md sobre superficie clara.
     */
    clases() {
      const conBrillo = this.variante === 'primario' && this.tamano === 'md' && this.superficie === 'clara'
      return [
        'gob-btn',
        CLASE_VARIANTE[this.variante],
        this.superficie === 'oscura' ? 'gob-btn-oscura' : '',
        this.tamano === 'sm' ? 'gob-btn-sm' : '',
        conBrillo ? 'shadow-glow' : '',
        CLASE_BLOQUE[this.bloque]
      ]
    }
  }
}
</script>
